import { Base, createApp } from '@studiometa/js-toolkit';
import { Menu } from '@studiometa/ui';

import { isDev } from './config.js';

import BackToTop from './atoms/BackToTop.js';
import Figure from './atoms/Figure/Figure.js';
import Alert from './atoms/Alert.js';
import Slider from './molecules/Slider/index.js';
import Accordion from './molecules/Accordion.js';
import ModalMedia from './molecules/ModalMedia/ModalMedia.js';
import ModalMediaTrigger from './molecules/ModalMedia/ModalMediaTrigger.js';
import WysiwygTable from './molecules/WysiwygTable.js';
import Header from './organisms/Header.js';
import Hero from './organisms/Hero.js';
import MobileBurgerMenu from './organisms/MobileBurgerMenu.js';
import Listing from './organisms/Listing/Listing.js';
import ListingAccordions from './organisms/Listing/ListingAccordions.js';
import ListingStatic from './organisms/Listing/ListingStatic.js';
import Frame from './organisms/Frame.js';
/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      '.wysiwyg table': WysiwygTable,
      BackToTop,
      Alert,
      Figure,
      Accordion,
      Slider,
      Menu,
      Frame,
      ModalMedia,
      ModalMediaTrigger,
      Header,
      Hero,
      MobileBurgerMenu,
      Listing,
      ListingAccordions,
      ListingStatic,
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.$log('mounted 🎉');
  }

  /**
   * Get global modal media
   * @returns {Base}
   */
  get modalMedia() {
    return this.$children.ModalMedia[0];
  }

  /**
   * On ModalMediaTrigger "Open"
   * @param {string} content InnerHtml from the template ref.
   */
  onModalMediaTriggerOpen(content) {
    this.modalMedia.open(content);
  }
}

export default createApp(App, document.body);
